import { render, staticRenderFns } from "./PxTreeView.vue?vue&type=template&id=35aa744b&"
import script from "./PxTreeView.vue?vue&type=script&lang=js&"
export * from "./PxTreeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports